import { analyticsUtils } from 'utils/analytics-utils';

/**
 * Событие должно срабатывать при клике на чекбокс поверхностей.
 */

export const gaClickOnSurface = ({ name, checked }: { name: string; checked: boolean }) =>
  analyticsUtils.sendEvent('GA:clickButton', {
    elementType: checked ? 'focus' : 'unfocus', // unfocus при снятии галочки
    elementBlock: 'productDetail / calc', // блок, в котором расположен элемент
    elementName: 'Какие поверхности вас интересуют?',
    elementText: name,
  });
